import { DialogTitle, Box, styled, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CachedIcon from '@mui/icons-material/Cached';

const StyledDialogTitle = styled(DialogTitle)({
  cursor: 'move',
  padding: '14px 16px',
  borderBottom: '1px solid rgba(0,0,0,0.08)',
});

const CloseButton = styled('div')<{ disabled?: boolean }>(({ disabled }) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  display: 'flex',
  alignItems: 'center',
  padding: '4px 0 4px',
  color: disabled ? '#999' : '#000',
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  '&:hover': {
    color: disabled ? '#999' : '#665',
  },
  '& svg': {
    fontSize: '20px',
  },
}));

const IconContainer = styled('span')({
  marginRight: '8px',
  display: 'flex',
  alignItems: 'center',
});

const TitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  fontSize: '15px',
  fontWeight: 600,
  paddingRight: '5px',
});

interface DialogTitleGlyntProps {
  title: string;
  closeModal: () => void;
  startIcon?: React.ReactNode | 'checkbox' | 'update';
  loading?: boolean;
}

const DialogTitleGlynt: React.FC<DialogTitleGlyntProps> = ({
  title,
  closeModal,
  startIcon,
  loading = false,
}) => {
  const theme = useTheme();

  const renderIcon = () => {
    if (!startIcon) return null;

    if (startIcon === 'checkbox') {
      return <CheckCircleOutlineIcon sx={{ color: theme.palette.primary.main }} />;
    }

    if (startIcon === 'update') {
      return <CachedIcon sx={{ color: theme.palette.primary.main }} />;
    }

    return startIcon;
  };

  return (
    <StyledDialogTitle id="draggable-dialog-title">
      <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <TitleContainer>
          {startIcon && <IconContainer>{renderIcon()}</IconContainer>}
          <span>{title}</span>
        </TitleContainer>
        <CloseButton
          onClick={!loading ? closeModal : undefined}
          role="button"
          aria-label="close"
          disabled={loading}
        >
          <CloseIcon />
        </CloseButton>
      </Box>
    </StyledDialogTitle>
  );
};
export default DialogTitleGlynt;
